import { useCollection } from "@/hooks/useCollection";
import type { Mission } from "@/lib/types";
import { Link } from "react-router-dom";

export default function Missions() {
  const { items } = useCollection<Mission>("missions");

  if (items.length === 0) return null;

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-block text-sm font-semibold text-primary-600">
            Nos missions
          </span>
          <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Des actions concrètes, au plus près des besoins
          </h2>
          <p className="mt-4 text-base text-foreground-600 leading-relaxed">
            Trois piliers guident notre engagement quotidien envers les plus
            démunis en Afrique et en Asie.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {items.map((mission, index) => (
            <div
              key={mission.title || index}
              className="group bg-background-50 rounded-lg border border-background-200 overflow-hidden transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="w-full aspect-[4/3] overflow-hidden">
                <img
                  src={mission.image}
                  alt={mission.title}
                  title={`${mission.title} — Humanity59`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-6">
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${mission.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-xl font-semibold text-foreground-950">
                  {mission.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {mission.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/actions"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 cursor-pointer"
          >
            Voir toutes nos actions
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}